export const topBar = {
  hi: '你好，{{username}}',
  accountSetting: '帳戶設定',
}
